module.exports = __webpack_public_path__ + "img/icon.1953f69a.png";